<div class="component">
    <div class="component__header">Header Basic 1 [{{configPath}}]:</div>
    <config-controls
        #configControls
        [sections]="sections"
        [fullConfigPath]="fullConfigPath"></config-controls>
    <config-currency-selector
        [configPath]="fullConfigPath + '.childConfigs.currency_selector'"></config-currency-selector>
</div>
